(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product-loop"]) return;
  try {
    
  $(document).on('click', 'a.edit-summary-product', function () {
    $('.custom_fixed_section_summary').css('display', 'none');
    $('span.custom_summary_text').removeClass('.popup_open_class');
    var edit_value = $(this).parents('.card-header').find('a.edit-summary-product').attr('data-attr');
    //var edit_value =  $('a.edit-summary-product').attr('data-attr');
    //alert(edit_value);
    $('body').removeClass('is_body_active');
    $(".tabs li[data-handle='" + edit_value + "']").trigger('click');
  });

  for (var prop in productArray) {
    if (productArray[prop].product_id != undefined) {
      html +=
        "<div class='card'><div class='custom_summary_icon_main'><span class='cutom_summary_sum_button_cross'>Summary</span><div class='close_button_svg'><svg class='custom_cross_icon_summary' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='#000000' version='1.1'  width='40px' height='40px' viewBox='0 0 94.926 94.926' xml:space='preserve'><g><path d='M55.931,47.463L94.306,9.09c0.826-0.827,0.826-2.167,0-2.994L88.833,0.62C88.436,0.224,87.896,0,87.335,0   c-0.562,0-1.101,0.224-1.498,0.62L47.463,38.994L9.089,0.62c-0.795-0.795-2.202-0.794-2.995,0L0.622,6.096   c-0.827,0.827-0.827,2.167,0,2.994l38.374,38.373L0.622,85.836c-0.827,0.827-0.827,2.167,0,2.994l5.473,5.476   c0.397,0.396,0.936,0.62,1.498,0.62s1.1-0.224,1.497-0.62l38.374-38.374l38.374,38.374c0.397,0.396,0.937,0.62,1.498,0.62   s1.101-0.224,1.498-0.62l5.473-5.476c0.826-0.827,0.826-2.167,0-2.994L55.931,47.463z'/></g></svg></div></div>";
      html +=
        "<div class='card-header' data-id='" +
        productArray[prop].product_id +
        "'><span class='custom_sum_prdct_img'><img class='custom_product_img_sum' src= '" +
        productArray[prop].product_image +
        "'>" +
        productArray[prop].product_name +
        " </span><img class='custom_variant_img_sum' src= '" +
        productArray[prop].variant_image +
        "'> <span class='custom_variant_header_upper'>" +
        productArray[prop].variant_title +
        " </span><span class='custom_variant_quantity_oyer_header'>" +
        productArray[prop].quantity +
        " </span><span class='custom_outer_heade_peirce'>" +
        productArray[prop].price +
        ' </span><span>' +
        productArray[prop].edit_button +
        '</span></div>';
      // html +="<div class='card-body'>"+productArr.summary+"</div>";
      html += "<div class='card-body'>";
      var summ = productArray[prop].summary;
      for (var propSum in summ) {
        // console.log(propSum);
        var sumArr = summ[propSum];
        for (var propSumArr in sumArr) {
          // console.log(propSumArr);
          if (productArray[prop].product_id == propSumArr) {
            html += sumArr[propSumArr];
          }
        }
      }
      html += '</div>';

      html += '</div>';
      html += '</div></div>';
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-with-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $('.button[href="#open-modal"]').on('click', function (e) {
      e.preventDefault();
      let modalID = $(this).data('modalid');
      $('#' + modalID).attr('open', 'open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
